import { LinkNewProps } from "../../components/linkNew/LinkNew";
import { IconTextNewProps } from "../../components/iconTextNew/IconTextNew";
import { StripBannerItem } from "@sourceful/shared-types";
import { getUrlFromTypeAndSlug } from "@lib/utils/urlHelper";

export function getStripBannerItems(stripBannerItems: StripBannerItem[]): IconTextNewProps[] {
  if (!stripBannerItems || stripBannerItems.length === 0) return [];

  const items = stripBannerItems.map(item => {
    const iconText = {
      icon: item.iconName,
      text: item.text,
    } as IconTextNewProps;

    let linkProps: LinkNewProps;

    if (item.link) {
      const { externalLink, internalLink } = item.link;

      if (externalLink && externalLink.link) {
        linkProps = {
          internal: externalLink.link.startsWith("/"),
          link: externalLink.link,
        };

        iconText.link = linkProps;
      } else if (internalLink && internalLink.slug) {
        linkProps = {
          internal: true,
          link: getUrlFromTypeAndSlug(internalLink._type, internalLink.slug),
        };

        iconText.link = linkProps;
      }
    }

    return iconText;
  });

  return items;
}
